import { Button, Drawer, TextOrHTML } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";

export type DialogDrawerProps = {
  /** Display name for the drawer header */
  displayName: string;
  /** HTML content describing the product */
  productInfo: string;
  /** Whether the drawer is open */
  isOpen: boolean;
  /** Whether coverage has been added */
  isCoverageAdded: boolean;
  /** Callback to close the drawer */
  onClose: () => void;
  /** Callback when CTA is clicked */
  onCtaClick: () => void;
};

export const DialogDrawer = ({
  displayName,
  productInfo,
  isOpen,
  isCoverageAdded,
  onClose,
  onCtaClick,
}: DialogDrawerProps) => (
  <Drawer
    isOpen={isOpen}
    onClose={onClose}
    direction="right"
    closeLabel="Close"
  >
    <Drawer.Header>
      <div className="mobius-dialogue-modal__header">{displayName}</div>
    </Drawer.Header>
    <Drawer.Content>
      <div className="mobius-dialogue-modal__body --has-footer">
        <TextOrHTML text={productInfo} htmlElementType="div" />
      </div>
      <div className="mobius-dialogue-modal__footer">
        <Button
          className={classNames("mobius-dialogue-modal__cta", {
            "--is-ghost": isCoverageAdded,
          })}
          onClick={onCtaClick}
        >
          {isCoverageAdded ? "Remove this coverage" : "Add this coverage"}
        </Button>
      </div>
    </Drawer.Content>
  </Drawer>
);

DialogDrawer.displayName = "DialogDrawer";
